import { UpdateContentMarketplaceMeta, UpdateContentMarketplacePayload } from 'types/store/UpdateContentMarketplace';
import { createAsyncReducer } from 'utils/Redux';

import { updateContentMarketplaceActions } from '../actions';

export default createAsyncReducer<UpdateContentMarketplaceMeta, UpdateContentMarketplacePayload>(updateContentMarketplaceActions);
